// export const getBotAnalytics = async payload => {
//   const startStr = encodeURIComponent(payload.analyticsStartDate.toISOString());
//   const endStr = encodeURIComponent(payload.analyticsEndDate.toISOString());
//   const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}/analytics?startDate=${startStr}&endDate=${endStr}`;
//   const options = {
//     method: "GET",
//     headers: {
//       Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
//       "x-workspace-id": payload.botODM.omniData.workspaceId,
//     },
//     body: undefined,
//   };

//   try {
//     const response = await fetch(url, options);
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error(error);
//     return Promise.reject(error);
//   }
// };

//this POS function only returns 30 days at a time.
export const getBotAnalytics = async payload => {
  const startStr = encodeURIComponent(payload.analyticsStartDate.toISOString());
  const endStr = encodeURIComponent(payload.analyticsEndDate.toISOString());

  const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}/analytics?startDate=${startStr}&endDate=${endStr}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    const responseArray = { records: data.records };

    return responseArray;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBot = async payload => {
  const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBotpressSummary = async payload => {
  const url = `https://status.botpress.com/api/v2/summary.json`;
  const options = {
    method: "GET",
    headers: {
      // Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      // "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchConversations = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ConversationsTable/rows/find";

  try {
    let body = {
      limit: payload.pageSize,
      offset: payload.pageIndex * payload.pageSize,
    };

    if (payload.sort != null) {
      Object.keys(payload.sort).forEach(key => {
        body["orderBy"] = key;
        body["orderDirection"] = payload.sort[key];
      });
    }

    if (payload.query != null) {
      body.filter = payload.query;
    }

    const options = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
        "x-bot-id": payload.botODM.omniData.botId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteConversation = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ConversationsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: [payload.conversationId] }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchFeedback = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/FeedbackTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.feedbackIDs }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.feedbackRecords, waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateChat = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ConversationsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.chatRecords, waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.feedbackRecords, waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#region assessments

export const searchAssessment = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteAssessments = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.assessmentIDs }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateAssessment = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.assessmentRecord], waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addAssessment = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.assessmentRecord], waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region products

export const searchProducts = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ProductsTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteProducts = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.productIDs }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateProduct = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.productRecord], waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addProduct = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.productRecord], waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region members

export const searchMembers = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/MembersTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region presented links

export const searchPresentedLinks = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/PresentedLinksTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region files

export const listBotpressFiles = async payload => {
  const params = new URLSearchParams();

  if (payload.nextToken != null) {
    params.append("nextToken", payload.nextToken);
  }

  if (payload.indexed != null) {
    params.append("indexed", payload.indexed);
  }

  const queryString = params.toString();
  const url = `https://api.botpress.cloud/v1/files${queryString ? `?${queryString}` : ""}`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const listAllBotpressFiles = async payload => {
  let allFiles = [];
  let nextToken = null;
  let lastToken = null;

  do {
    lastToken = nextToken;

    const data = await listBotpressFiles({
      ...payload,
      nextToken,
      indexed: payload.indexed ?? true,
    });

    allFiles = allFiles.concat(data.files || []);
    nextToken = data.meta?.nextToken ? data.meta.nextToken : null;
  } while (nextToken != null && nextToken !== lastToken);

  return allFiles;
};

export const listBotpressFilePassages = async payload => {
  const params = new URLSearchParams();

  if (payload.nextToken != null) {
    params.append("nextToken", payload.nextToken);
  }

  if (payload.limit != null) {
    params.append("limit", payload.limit);
  }

  const queryString = params.toString();
  const url = `https://api.botpress.cloud/v1/files/${payload.fileId}/passages${
    queryString ? `?${queryString}` : ""
  }`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const listAllBotpressFilePassages = async payload => {
  let allPassages = [];
  let nextToken = null;
  let lastToken = null;

  do {
    lastToken = nextToken;

    const data = await listBotpressFilePassages({
      ...payload,
      nextToken,
      limit: payload.limit ?? 200,
    });

    allPassages = allPassages.concat(data.passages || []);
    nextToken = data.meta?.nextToken ? data.meta.nextToken : null;
  } while (nextToken != null && nextToken !== lastToken);

  return allPassages;
};

export const getBotpressScrapedWebsiteUrls = async payload => {
  const files = await listAllBotpressFiles({
    ...payload,
    indexed: true,
  });

  let scrapedWebsiteUrls = [];

  const isValidWebsiteUrl = url => {
    if (url == null || url === "") {
      return false;
    }

    if (url.includes("amazonaws.com")) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
    } catch (error) {
      return false;
    }
  };

  for (const file of files) {
    // The authoritative URL of the scraped web page lives on the file's tags —
    // Botpress sets tags.pageUrl for web-page knowledge-base sources. Prefer it
    // over passage/metadata fields, which for many bots point at embedded assets
    // (hero images, favicons) rather than the page itself, so matching those
    // against a sitemap never lines up.
    const pageUrl = [
      file.tags?.pageUrl,
      file.tags?.url,
      file.tags?.sourceUrl,
      file.metadata?.sourceUrl,
      file.metadata?.url,
      file.metadata?.pageUrl,
      file.metadata?.websiteUrl,
      file.metadata?.webpageUrl,
      file.metadata?.documentUrl,
    ].find(isValidWebsiteUrl);

    let uniqueUrls;

    if (pageUrl) {
      uniqueUrls = [pageUrl];
    } else {
      // Fallback for data shapes that don't tag the page URL: scan the file's
      // passages for any embedded page URL.
      const passages = await listAllBotpressFilePassages({
        ...payload,
        fileId: file.id,
      });

      const passageUrls = passages
        .flatMap(passage => [
          passage.meta?.sourceUrl,
          passage.meta?.url,
          passage.meta?.pageUrl,
          passage.meta?.websiteUrl,
          passage.meta?.webpageUrl,
          passage.meta?.documentUrl,
          passage.metadata?.sourceUrl,
          passage.metadata?.url,
          passage.metadata?.pageUrl,
          passage.metadata?.websiteUrl,
          passage.metadata?.webpageUrl,
          passage.metadata?.documentUrl,
        ])
        .filter(isValidWebsiteUrl);

      uniqueUrls = [...new Set(passageUrls)];
    }

    if (uniqueUrls.length > 0) {
      scrapedWebsiteUrls.push({
        fileId: file.id,
        key: file.key,
        contentType: file.contentType,
        tags: file.tags,
        metadata: file.metadata,
        createdAt: file.createdAt,
        updatedAt: file.updatedAt,
        scrapedUrls: uniqueUrls,
      });
    }
  }

  return scrapedWebsiteUrls;
};

export const getBotpressMarkdownFiles = async payload => {
  const files = await listAllBotpressFiles({
    ...payload,
    indexed: true,
  });

  const isMarkdownFile = file => {
    const key = file.key || "";
    const name = file.name || "";
    const fileName = file.fileName || "";
    const contentType = file.contentType || "";
    const metadataFileName =
      file.metadata?.fileName ||
      file.metadata?.filename ||
      file.metadata?.name ||
      file.metadata?.sourceFile ||
      "";

    return (
      key.toLowerCase().endsWith(".md") ||
      name.toLowerCase().endsWith(".md") ||
      fileName.toLowerCase().endsWith(".md") ||
      metadataFileName.toLowerCase().endsWith(".md") ||
      key.toLowerCase().endsWith(".markdown") ||
      name.toLowerCase().endsWith(".markdown") ||
      fileName.toLowerCase().endsWith(".markdown") ||
      metadataFileName.toLowerCase().endsWith(".markdown") ||
      contentType === "text/markdown" ||
      contentType === "text/x-markdown"
    );
  };

  const getPassageContent = passage => {
    return (
      passage.content ||
      passage.text ||
      passage.value ||
      passage.chunk ||
      passage.pageContent ||
      passage.data?.content ||
      passage.data?.text ||
      ""
    );
  };

  const markdownFiles = [];

  for (const file of files.filter(isMarkdownFile)) {
    const passages = await listAllBotpressFilePassages({
      ...payload,
      fileId: file.id,
    });

    const content = passages.map(getPassageContent).filter(Boolean).join("\n");

    markdownFiles.push({
      id: file.id,
      name:
        file.key ||
        file.name ||
        file.fileName ||
        file.metadata?.fileName ||
        file.metadata?.filename ||
        file.id,
      fileName:
        file.key ||
        file.name ||
        file.fileName ||
        file.metadata?.fileName ||
        file.metadata?.filename ||
        file.id,
      key: file.key,
      contentType: file.contentType,
      tags: file.tags,
      metadata: file.metadata,
      createdAt: file.createdAt,
      updatedAt: file.updatedAt,
      content,
      passages,
    });
  }

  return markdownFiles;
};

// Create or update a Botpress file from raw bytes. The `key` is the unique
// identifier across the bot, so re-PUTting an existing key overwrites it — this
// is the primitive the knowledge-base migrator uses to copy files between bots.
// Botpress needs the byte size up front and hands back a presigned uploadUrl we
// then PUT the content to. Returns the create response, or a { code, message }
// error shape on failure.
export const upsertBotpressFile = async payload => {
  const { blob } = payload;
  const contentType = payload.contentType || blob?.type || "application/octet-stream";

  const createFileResponse = await fetch("https://api.botpress.cloud/v1/files", {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      key: payload.key,
      size: blob.size,
      contentType,
      index: payload.index ?? true,
      tags: payload.tags || {},
      metadata: payload.metadata || {},
    }),
  });

  const createFileData = await createFileResponse.json();

  if (Object.hasOwn(createFileData, "code")) {
    return createFileData;
  }

  const uploadUrl = createFileData.file?.uploadUrl || createFileData.uploadUrl;

  if (!uploadUrl) {
    return {
      code: 400,
      message: "Botpress did not return an upload URL for the file.",
    };
  }

  const uploadResponse = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": contentType,
    },
    body: blob,
  });

  if (!uploadResponse.ok) {
    return {
      code: uploadResponse.status,
      message: "Failed to upload file content.",
    };
  }

  return createFileData;
};

export const upsertBotpressMarkdownFile = async payload => {
  const content = payload.content || "";
  const blob = new Blob([content], { type: "text/markdown" });

  return upsertBotpressFile({
    botODM: payload.botODM,
    key: payload.key,
    blob,
    contentType: "text/markdown",
    index: payload.index,
    tags: payload.tags,
    metadata: payload.metadata,
  });
};

// Fetch a single file's metadata, including the downloadUrl used to pull its
// content. The downloadUrl is a short-lived presigned URL, so fetch it right
// before downloading rather than caching it.
export const getBotpressFile = async payload => {
  const url = `https://api.botpress.cloud/v1/files/${payload.fileId}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// Download a file's raw content as a Blob. Resolves the presigned downloadUrl
// via getBotpressFile, then fetches the bytes directly from storage.
export const downloadBotpressFileContent = async payload => {
  const data = await getBotpressFile(payload);
  const downloadUrl =
    data.file?.downloadUrl || data.file?.url || data.downloadUrl || data.url || null;

  if (!downloadUrl) {
    throw new Error(
      `Botpress did not return a download URL for file ${payload.fileId}.`,
    );
  }

  const response = await fetch(downloadUrl);
  if (!response.ok) {
    throw new Error(
      `Failed to download file ${payload.fileId} (status ${response.status}).`,
    );
  }

  return response.blob();
};

export const deleteBotpressFile = async payload => {
  const url = `https://api.botpress.cloud/v1/files/${payload.fileId}`;
  const options = {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

export const loadConversation = async payload => {
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
    },
  };

  const url = `https://api.botpress.cloud/v1/chat/messages?conversationId=${payload.conversationId}`;

  try {
    let nextToken = null;
    let lastToken = null;
    let allMessages = [];
    let theResult = null;
    do {
      let builtURL = url;
      lastToken = nextToken;
      if (nextToken != null) {
        builtURL = url + `&nextToken=${nextToken}`;
      }

      const response = await fetch(builtURL, options);
      theResult = await response.json();
      lastToken = nextToken;
      nextToken = theResult.meta?.nextToken ? theResult.meta?.nextToken : null;
      allMessages = allMessages.concat(theResult.messages);
    } while (nextToken != null && nextToken !== lastToken);

    return allMessages;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createUser = async payload => {
  const options = {
    method: "POST",
    headers: {
      // Authorization: `Bearer ${payload.omniData.accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: "AKTest",
    }),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/users`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//Create Conversation
export const createConversation = async payload => {
  const options = {
    method: "POST",
    headers: {
      "x-user-key": payload.key,
      "Content-Type": "application/json",
    },
    // An empty body lets Botpress generate the conversation id for us.
    body: JSON.stringify({}),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/conversations`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// Send Message
// Requires payload.conversationId and payload.text in addition to the user key.
export const sendMessage = async payload => {
  const options = {
    method: "POST",
    headers: {
      "x-user-key": payload.key,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      conversationId: payload.conversationId,
      payload: {
        type: "text",
        text: payload.text,
      },
    }),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/messages`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// List the messages of a conversation via the Chat API (uses the user key,
// not the admin token). Returns the raw { messages: [...] } payload.
export const listConversationMessages = async payload => {
  const options = {
    method: "GET",
    headers: {
      "x-user-key": payload.key,
      "Content-Type": "application/json",
    },
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/conversations/${payload.conversationId}/messages`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchConfiguration = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ConfigurationTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
